import React from 'react';
import { Link } from 'react-router-dom';  // Import Link

const ConsultingPrice = () => {
  const codes = {
    'Mentoring Session (60–90 Minutes)': {
      offerPrice: '50,000 BDT',
      topics: [
        'A powerful one-time strategy session to unlock clarity, remove mental or business blocks, and take decisive action immediately.',
        'Best for: Entrepreneurs needing direction, decision-making support, or personalized solutions.',
      ],
    },
    'Half-Day Consulting Session (4 Hours)': {
      offerPrice: '1,20,000 BDT',
      topics: [
        'Deep-dive into your business, life systems, or income strategy with Jahid Hasan. Walk away with custom-built frameworks and a roadmap to growth.',
        'Best for: Entrepreneurs, professionals, or founders ready to restructure or scale.',
      ],
    },
    'Full-Day Strategic Mentoring (8 Hours)': {
      offerPrice: '1,80,000 BDT',
      topics: [
        'Spend an entire day with Jahid Hasan — full focus, full immersion. Design a new life/business blueprint, refine monetization models, and architect income systems with personalized execution plans.',
        'Best for: Serious players committed to major transformation.',
      ],
    },
    'Audit Your Life, Business & Income(3 Months)': {
      offerPrice: '3,00,000 BDT',
      topics: [
        'Comprehensive audit across personal, business, and financial aspects to map out a clear path to success.',
        'Clarity & Identity Audit – Discover your life’s direction, personal strengths, and what’s holding you back.',
        'Business Structure & Profit Review – Diagnose your business model, offer, team, and systems to unlock growth.',
        'Income Stream & Wealth Mapping – Analyze all income sources, pricing, and create a path to financial freedom.',
      ],
    },
  };

  const boxStyle = {
    flex: '1 1 400px', // <-- Base width for the card
    padding: '20px',
    border: '1px solid violet',
    backgroundColor: 'rgba(238, 130, 238, 0.1)',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  // Helper function to extract numeric value from price
  const extractAmount = (priceStr) => {
    return priceStr.replace(/[^\d]/g, '');
  };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
        {Object.entries(codes).map(([codeTitle, { offerPrice, topics }]) => (
          <div key={codeTitle} style={boxStyle}>
            <div>
              <h3 style={{ color: '', marginBottom: '10px' }} className='text-center'>{codeTitle}</h3>
              <ul style={{ paddingLeft: '20px' }}>
                {topics.map((topic, idx) => (
                  <li key={idx} style={{ marginBottom: '8px' }}>{topic}</li>
                ))}
              </ul>
            </div>
            <div style={{ marginTop: 'auto' }} className="text-center">
              <h4 style={{ margin: '20px 0 10px 0' }}>
                Fee:
                <span style={{ color: 'green', fontWeight: 'bold', paddingLeft: '10px' }}>{offerPrice}</span>
              </h4>
              <div className="text-center">
                <Link
                  className="btn-default"
                  to={`/order?service=Consulting&package=${encodeURIComponent(codeTitle)}&amount=${extractAmount(offerPrice)}`}
                >
                  Purchase Now
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="w-full text-center px-5 mt-5 pt-5">
        <h5>
          <strong>
            **Spots are limited. Every consulting package is selectively offered to ensure results. Apply now to book your session.**
          </strong>
        </h5>
      </div>
    </div>
  );
};

export default ConsultingPrice;
